module.exports = __webpack_public_path__ + "img/rack_img.8aa49980.jpg";